import { InformationMessage } from "nemuru-components";
import React, { Fragment } from "react";
import Text from "../../shared/components/Text";

const errorJsxMessages = {
  // no hay ninguna cuenta de pago
  RNCP: (
    <Fragment>
      <InformationMessage
        type="warning"
        message={<Text tId={"ERROR_RNCP_TITLE"} />}
      />
      <p className="mt-4 d-block">
        <Text tId={"ERROR_RNCP_TEXT"} />
      </p>
    </Fragment>
  ),
  // Identificación no coincide
  RIDN: (
    <Fragment>
      <InformationMessage
        type="warning"
        message={<Text tId={"ERROR_RIDN_TITLE"} />}
      />
      <p className="mt-4 d-block">
        <Text tId={"ERROR_RIDN_TEXT"} />
      </p>
    </Fragment>
  ),
  // Error al comprobar identificación
  RECI: (
    <Fragment>
      <InformationMessage
        type="warning"
        message={<Text tId={"ERROR_RECI_TITLE"} />}
      />
      <p className="mt-4 d-block">
        <Text tId={"ERROR_RECI_TEXT"} />
      </p>
    </Fragment>
  ),
  default: (
    <Fragment>
      <InformationMessage
        type="warning"
        message={
          <div>
            <Text tId={"ERROR_BR_DEFAULT_TITLE"} />
          </div>
        }
      />
      <p>
        <Text tId={"ERROR_BR_DEFAULT_TEXT"} />
      </p>
    </Fragment>
  ),
};

export const returnCodeErrorMessages = {
  RNCP: errorJsxMessages.RNCP,
  RIDN: errorJsxMessages.RIDN,
  RECI: errorJsxMessages.RECI,
  RNAH: errorJsxMessages.RECI,
  default: errorJsxMessages.default,
};
